// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__JNJQ_","adobe-logo":"Footer_adobe-logo__K61Bi","links":"Footer_links__W8RrQ","link":"Footer_link__iPwls"};